import React from "react";
import PropTypes from "prop-types";

import { Title } from "./Title";

import "./style.scss";

export function TitleNode(props) {
  const getIsCorrect = (c) => c.answerId.includes(c.droppedId);

  const getFeedback = (c, isCorrect) => {
    if (isCorrect) return "";
    else return c.feedbackMessage;
  };

  const getIsEmpty = (c) => c.droppedId === null;

  const onDropStep = (positionId) =>
    React.useCallback((params) => {
      props.onDropStep({ ...params, positionId, nodeId: props.nodeId });
    }, []);

  const onRemoveStep = (positionId) =>
    React.useCallback(() => {
      props.onRemoveStep({ positionId, nodeId: props.nodeId });
    }, []);

  const techniqueComponent = (nodeComponent) => {
    const isCorrect = getIsCorrect(nodeComponent);
    return React.createElement(props.techniqueNode, {
      isCorrect,
      key: nodeComponent.id,
      tabIndex: props.tabIndex,
      title: nodeComponent.title,
      image: nodeComponent.image,
      isEmpty: getIsEmpty(nodeComponent),
      droppedId: nodeComponent.droppedId,
      onDrop: onDropStep(nodeComponent.id),
      description: nodeComponent.description,
      placeHolder: nodeComponent.placeHolder,
      onRemove: onRemoveStep(nodeComponent.id),
      feedbackMessage: getFeedback(nodeComponent, isCorrect),
      showTooltip: nodeComponent.showTooltip,
      ...props.techniqueNode.props,
    });
  };

  return (
    <div className="design-view__titleNode">
      <Title text={props.nodeTitle} className="design-view__titleNode--title" />
      {props.nodeComponents.map(techniqueComponent)}
    </div>
  );
}

TitleNode.propTypes = {
  /**
   * TabIndex to set on component
   */
  tabIndex: PropTypes.number,
  /**
   * title of the Node
   */
  nodeTitle: PropTypes.string,
  /**
   * List of Components too display in Node
   */
  nodeComponents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Uniqe id of component
       */
      id: PropTypes.number,
      /**
       * Type of NodeComponent
       */
      type: PropTypes.oneOf(["TECHNIQUE_CARD"]),
      /**
       * Title of TechiniqueNode
       */
      title: PropTypes.string,
      /**
       * Description of TechiniqueNode
       */
      description: PropTypes.string,
      /**
       * Image URL for OutcomeNode
       */
      image: PropTypes.string,
      /**
       * Placeholder text when no Node is dropped
       */
      placeHolder: PropTypes.string,
      /**
       * Feedback message
       */
      feedbackMessage: PropTypes.string,
      /**
       * List of Ids' of Node/Component that are correct for the spot
       */
      answerId: PropTypes.arrayOf(PropTypes.number),
      /**
       * UniqueId of option dropped in the node
       */
      droppedId: PropTypes.number,
    })
  ),
  /**
   * React Component to be used as Technique Component
   */
  techniqueNode: PropTypes.elementType,
  /**
   * Function for when an Option in dropped in Node
   */
  onDropStep: PropTypes.func,
  /**
   * Function for when a Step is removed from Node
   */
  onRemoveStep: PropTypes.func,
};

TitleNode.defaultProps = {
  nodeComponents: [],
  tabIndex: 0,
  nodeTitle: "",
};
